import { gql } from "apollo-boost";

export const CREATE_USER = gql`
  mutation CreateUser($data: UserInput!) {
    createUser(data: $data) {
      id
    }
  }
`;

export const CREATE_USER_V2 = gql`
  mutation CreateUserV2($data: UserInput!) {
    createUserV2(data: $data) {
      status
      msg
      tag
    }
  }
`;

export const DELETE_USER = gql`
  mutation DeleteUser($where: UserWhereInputOne!) {
    deleteUser(where: $where) {
      id
    }
  }
`;

export const UPDATE_USER = gql`
  mutation UpdateUser($data: UserInput!, $where: UserWhereInputOne!) {
    updateUser(data: $data, where: $where) {
      id
    }
  }
`;

export const UPDATE_USER_V2 = gql`
  mutation UpdateUserV2($data: UserInput!, $where: UserWhereInputOne!) {
    updateUserV2(data: $data, where: $where) {
      status
      msg
      tag
    }
  }
`;

export const ON_OFF_USER_V2 = gql`
  mutation OnOffUserV2($where: UserWhereInputOne!, $data: UserInput!) {
    onOffUserV2(where: $where, data: $data) {
      status
      msg
      tag
    }
  }
`;
